if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.loadingSpinner = this.querySelector('.loading__spinner');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // منع الضغط مرتين
        if (
          this.submitButton.disabled ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove('hidden');
        }

        const formData = new FormData(this.form);

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        if (!variantId) {
          this.handleErrorMessage('Please select a product option.');
          this.finishLoading();
          return;
        }

        // 1. إضافة المنتج للسلة
        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: formData
        })
          .then(async (response) => {
            const data = await response.json();

            if (!response.ok || data.status) {
              throw new Error(
                data.description ||
                data.message ||
                'Unable to add this product to cart.'
              );
            }

            return data;
          })

          // 2. التأكد أن Shopify زاد المنتج فعلاً
          .then(() => {
            return fetch(routes.cart_url + '.js?v=' + Date.now(), {
              method: 'GET',
              headers: {
                'Accept': 'application/json',
                'Cache-Control': 'no-cache'
              },
              cache: 'no-store'
            });
          })

          .then((response) => {
            if (!response.ok) {
              throw new Error('Unable to verify cart.');
            }

            return response.json();
          })

          .then((cart) => {
            if (!cart || cart.item_count < 1) {
              throw new Error('Product was not added to cart.');
            }

            // 3. المنتج تزاد بنجاح
            // دّي الزبون مباشرة للـCheckout
            window.location.assign('/checkout');
          })

          .catch((error) => {
            console.error('Add to cart error:', error);

            this.handleErrorMessage(
              error.message ||
              'Something went wrong. Please try again.'
            );

            this.finishLoading();
          });
      }

      finishLoading() {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');

        if (this.loadingSpinner) {
          this.loadingSpinner.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');

          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}